import { useQuery } from "@tanstack/react-query"
import { segmentGroupStatsQuery } from "../lib/segmentGroupStatsQuery"

export function useSegmentGroupStatsQuery(...args: Parameters<typeof segmentGroupStatsQuery>) {
  return useQuery(segmentGroupStatsQuery(...args))
}
